'use strict';

(function (angular) {
    angular.module('zp.map', []);
})(window.angular);